export const buildCategoryMap = menus => {
  const map = new Map();
  (menus || []).forEach(menu => {
    (menu.children || []).forEach(category => {
      (category.children || []).forEach(product => {
        const id = product.id;
        if (id) map.set(String(id), category.name);
      });
    });
  });
  return map;
};



// WEBPACK FOOTER //
// ./src/utils/client/categoryMap.js